export default "{\n    \"emptyStateLabel\": \"Aucun résultat trouvé\"\n}\n"